import * as React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';

type Props = {
  body: string,
  iconName: string | undefined | null,
  qa: string
};

class TutorialCarouselSlideCustom extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { body, iconName, qa } = this.props;

    return (
      <section
        className="tutorial-carousel-slide-custom"
        data-qa={qa}
      >
        <div className="tutorial-carousel-slide-custom__icon">
          {
            iconName &&
              <SVGIcon
                name={iconName}
                width={129}
                height={121}
              />
          }
        </div>
        <div
          className="tutorial-carousel-slide-custom__body"
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </section>
    );
  }
}

export default TutorialCarouselSlideCustom;
